export enum CommonSteps {
  communicationStep = 'communicationStep',
  detailsStep = 'detailsStep',
  emailConfigurationStep = 'emailConfigurationStep',
  publicationStep = 'publicationStep',
}

export enum CommonGroups {
  agenda = 'agenda',
  restrictedAccess = 'restrictedAccess',
  biogenLincConfig = 'biogenLincConfig',
  cventConfig = 'cventConfig',
  coorganizers = 'coorganizers',
  optionalInformations = 'optionalInformations',
  participantPhoneNumber = 'participantPhoneNumber',
  invitees = 'invitees',
  primaryInformations = 'primaryInformations',
  speakers = 'speakers',
  timeSlot = 'timeSlot',
  userGroup = 'userGroup',
  sessionInformation = 'sessionInformation',
  registerParticipant = 'registerParticipant',
  emailNotes = 'emailNotes',
  testing = 'testing',
  eventPdf = 'eventPdf',
  emailsPdf = 'emailsPdf',
  navigationConfig = 'navigationConfig',
  teamContactCheckbox = 'teamContactCheckbox',
  teamContactEmail = 'teamContactEmail',
  teamContactDescription = 'teamContactDescription',
  attendanceProof = 'attendanceProof',
}
